import { KnowledgeGraphView } from '@/components/knowledge-graph-view/KnowledgeGraphView'
import { useKnowledgeGraphAgentBridge } from '@/features/cases/hooks/useKnowledgeGraphAgentBridge'
import { useCaseContext } from '../../CaseContext'
import { useInvestigateContext } from '../../InvestigateContext'

export default function KnowledgeGraphPage() {
  const { caseId } = useCaseContext()
  const { componentFilter, activeGraphFilters, graphFocusNodeId, setGraphFocusNodeId, addFilter } =
    useInvestigateContext()

  const registerGraphActionHandler = useKnowledgeGraphAgentBridge()

  return (
    <KnowledgeGraphView
      caseId={caseId}
      componentFilter={componentFilter}
      activeGraphFilters={activeGraphFilters}
      externalSelectedNodeId={graphFocusNodeId}
      onExternalNodeHandled={() => setGraphFocusNodeId(null)}
      onAddFilter={addFilter}
      onRegisterGraphActionHandler={registerGraphActionHandler}
    />
  )
}
